export class MyAssertError extends Error {}

const DEBUG: boolean = false;

export function myAssert(
    condition: () => boolean,
    message: string | undefined = undefined,
    throwError: boolean = true,
): void {
    if (DEBUG && !condition()) {
        if (throwError) {
            throw new MyAssertError(message);
        } else {
            console.log('NE BI TREBALO OVO OVAKO: ' + message);
        }
    }
}

export function myConsoleLog(message?: any, ...optionalParams: any[]) {
    if (DEBUG) {
        console.log(message, optionalParams);
    }
}
